import axios from "axios";
import { API_URL } from "@/helpers";

export const statsService = {
  getCharts,
  getMilestone,
  getPilotTotalMissions,
  getPilotTotalMissionsAll,
  getPilotRangeTotalMissions,
  getPilotRangeTotalMissionsAll,
  getPilotTotalHours,
  getPilotRangeTotalHours,
  getPilotCurrentDays,
  getDroneTotalHours,
  getDroneRangeTotalHours,
  getDroneCurrentHours
};

export function getCharts(type, startTime, endTime) {
  return axios.get(`${API_URL}/1/stats/charts/${type}/${startTime}/${endTime}`);
}

export function getMilestone() {
  return axios.get(`${API_URL}/1/stats/milestone/`);
}

export function getPilotTotalMissions() {
  return axios.get(`${API_URL}/1/stats/pilot/totalmissions/`);
}

export function getPilotTotalMissionsAll() {
  return axios.get(`${API_URL}/1/stats/pilot/totalmissionsall/`);
}

export function getPilotRangeTotalMissions(startTime, endTime) {
  return axios.get(
    `${API_URL}/1/stats/pilot/rangetotalmissions/${startTime}/${endTime}`
  );
}

export function getPilotRangeTotalMissionsAll(startTime, endTime) {
  return axios.get(
    `${API_URL}/1/stats/pilot/rangetotalmissionsall/${startTime}/${endTime}`
  );
}

export function getPilotTotalHours() {
  return axios.get(`${API_URL}/1/stats/pilot/totalhours/`);
}

export function getPilotRangeTotalHours(startTime, endTime) {
  return axios.get(
    `${API_URL}/1/stats/pilot/rangetotalhours/${startTime}/${endTime}`
  );
}

export function getPilotCurrentDays() {
  return axios.get(`${API_URL}/1/stats/pilot/currentdays/`);
}

export function getDroneTotalHours() {
  return axios.get(`${API_URL}/1/stats/drone/totalhours/`);
}

export function getDroneRangeTotalHours(startTime, endTime) {
  return axios.get(
    `${API_URL}/1/stats/drone/rangetotalhours/${startTime}/${endTime}`
  );
}

export function getDroneCurrentHours() {
  return axios.get(`${API_URL}/1/stats/drone/currenthours/`);
}
